import { render, staticRenderFns } from "./AllPix.vue?vue&type=template&id=c681af1a"
import script from "./AllPix.vue?vue&type=script&lang=js"
export * from "./AllPix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports